import axios from "axios";

export default axios.create({
 baseURL: import.meta.env.VITE_APP_AXIOS,// `https://www.uma.pt/api`,
 headers: {
    "Accept": "application/json",
    "Content-Type": "application/json"
 }
})